import React from 'react'
import ChevronIcon from './ChevronIcon'

import { Border, Color, Gap, Responsive, Size } from 'const'
import styled from 'styled-components'
import cn from 'classnames'

const MenuCollapse = ({ onClick, icon, title, description = '', collapse = true }) => {
  const [open, setOpen] = React.useState(false)

  const boxClassName = cn('menu-box', {
    open: open,
  })

  const toggle = () => {
    if (collapse) {
      setOpen(!open)
    }
  }

  const toggleBox = () => {
    if (!collapse) {
      // eslint-disable-next-line no-unused-expressions
      onClick?.()
    }
  }

  return (
    <Box className={boxClassName} onClick={toggleBox} collapse={collapse}>
      <BoxIcon>
        <img alt="menu icon" className="menu-icon" src={icon} />
      </BoxIcon>
      <BoxContent>
        <h3 className="title">{title}</h3>
        <h5 className="description">{description}</h5>
      </BoxContent>
      <BoxAction onClick={toggle} collapse={collapse}>
        <ChevronIcon className="icon" />
      </BoxAction>
    </Box>
  )
}

const Box = styled.div`
  border: 1px solid ${Color.BORDER.MENU};
  border-radius: ${Border.MENU.RADIUS};
  padding: 24px 16px;
  display: flex;
  align-items: center;
  gap: ${Gap.LG};
  &.open .icon {
    transform: rotate(90deg);
  }
  ${(props) => !props.collapse && 'cursor: pointer;'}
`

const BoxContent = styled.div`
  flex: 1;

  .title {
    font-weight: 700;
    font-size: ${Size.FONT.BIGGER};
  }

  .description {
    font-weight: 500;
    font-size: ${Size.FONT.BIG};

    @media screen and (max-width: ${Responsive.XS.DOWN}px) {
      font-size: ${Size.FONT.REGULAR};
    }
  }
`
const BoxIcon = styled.div`
  max-width: 32px;

  @media screen and (max-width: ${Responsive.XS.DOWN}px) {
    max-width: 6.2vw;
  }
`
const BoxAction = styled.div`
  .icon {
    transition: transform 0.4s ease;
    fill: ${Color.FONT.MENU_DARK};
  }
  ${(props) => props.collapse && 'cursor: pointer;'}
`

export default MenuCollapse
